module.exports = __webpack_public_path__ + "img/18.bbc4ceed.jpg";